import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AlertService } from "ngx-alerts";
import { NgxSpinnerService } from "ngx-spinner";
import { Payment } from "src/app/model/payment.model";
import { DlaService } from "src/app/shared/dla.service";

@Component({
  selector: "app-coupon",
  templateUrl: "./coupon.component.html",
  styleUrls: ["./coupon.component.css"],
})
export class CouponComponent implements OnInit {
  couponForm: FormGroup;
  @ViewChild("payBtn", { static: false }) payBtn: ElementRef<HTMLElement>;
  buttonText: String = "Submit";
  submitted = false;
  sessions: any[];
  year: string;
  selected: any;
  qty: number;
  my_email = "";
  amount = 100;
  reference = "";

  message_display: string;

  couponTypes: any[] = [
    { id: "MULTIPLE", name: "Multiple" },
    { id: "SINGLE", name: "Single" },
  ];

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private dlaService: DlaService
  ) {
    this.couponForm = this.formBuilder.group({
      couponType: ["", Validators.required],
      fullname: ["", Validators.required],
      sessionId: ["", Validators.required],
      companyName: ["", Validators.required],
      phoneNumber: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      email: [
        "",
        [
          Validators.required,
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$"),
        ],
      ],
      quantity: ["", [Validators.required, Validators.pattern("^[0-9]*$")]]
    });

    this.loadScripts();
  }

  ngOnInit() {
    this.reference = `ref-${Math.ceil(Math.random() * 10e13)}`;
    this.year = new Date().getFullYear().toString();

    this.my_email = "admin@domain.com";

    this.spinner.show();
    this.dlaService.getCurrentSessionForCoupon().subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {
          //console.log(data);
          this.sessions = data.sessions;
        } else {
          this.alertService.danger(data.message);
        }
      },
      (error) => {
        this.spinner.hide();
        this.alertService.danger("An error occurred, Please try again");
      }
    );
  }

  get f() {
    return this.couponForm.controls;
  }

  checkSeletedType(item: any) {
    console.info(item);

    this.selected = this.sessions.find((x) => x.ss == item);

    // if (event === "TEENAGER") {
    //   this.isTeenager = true;
    //   this.buttonText = "Create Account";
    //   this.registerForm.controls["email"].setValue("");
    //   this.registerForm.controls["company_name"].setValue("");
    //   this.registerForm.controls["company_email"].setValue("");
    //   this.registerForm.controls["consent"].setValue(false);
    // } else {
    //   this.isTeenager = false;
    //   this.buttonText = "Next";
    //   this.registerForm.controls["consent"].setValue(true);
    // }
  }

  checkQuantity(quant: any) {
    //console.info(quant);

    this.qty = quant;

    this.message_display = (this.selected.fee * this.qty).toFixed(2);

    this.amount = this.selected.fee * this.qty * 100;
  }

  setEmail(email: any) {

    this.my_email = this.couponForm.value.email;

  }

  submitCoupon() {
    this.submitted = true;

    if (this.couponForm.invalid) {
      return;
    }

    let el: HTMLElement = this.payBtn.nativeElement;
    el.click();
    return;

  }

  paymentInit() {
    console.log("Payment initialized");
  }

  paymentDone(ref: any) {
    // this.title = 'Payment successfull';
    //console.log(ref);

    if (ref.status === "success") {
      let paymentRequest: any = {
        coupon_type: this.couponForm.value.couponType,
        email: this.couponForm.value.email,
        session_id: this.couponForm.value.sessionId,
        amount: this.amount /100,
        fullname: this.couponForm.value.fullname,
        quantity:  this.qty,
        reference: ref.reference,
        company_name: this.couponForm.value.companyName,
        phone_number: this.couponForm.value.phoneNumber,
      };

      this.processCoupon(paymentRequest);
    }
  }

  processCoupon(payload:any){
    console.log(payload);
    this.spinner.show();
    this.dlaService.processCoupon(payload).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        //console.log("Coupon Response:", data);
        if (!error) {
          //this.alertService.success(data.message);
          this.router.navigateByUrl(
              `/confirm-coupon?type=success&message=${data.message}`
            );
        } else {
          //this.alertService.danger(data.message);
          this.router.navigateByUrl(
              `/confirm-coupon?type=error&message=${data.message}`
            );
        }

        // this.couponForm.controls["sessionId"].setValue('');
        // this.couponForm.controls["couponType"].setValue('');
        // this.couponForm.controls["email"].setValue('');
        // this.couponForm.controls["fullname"].setValue('');
        // this.couponForm.controls["quantity"].setValue('');

        this.couponForm.reset();
        this.message_display = '';
      },
      (error) => {
        this.spinner.hide();
        this.alertService.danger("An error occurred, Please try again");
        this.couponForm.reset();
      }
    );
    this.reference = `ref-${Math.ceil(Math.random() * 10e13)}`;
  }

  getNowDate() {
    //return string
    var returnDate = "";
    //get datetime now
    var today = new Date();
    //split
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //because January is 0!
    var yyyy = today.getFullYear();

    returnDate += yyyy;
    //Interpolation date
    if (mm < 10) {
      returnDate += `-0${mm}`;
    } else {
      returnDate += `-${mm}`;
    }

    if (dd < 10) {
      returnDate += `-0${dd}`;
    } else {
      returnDate += `-${dd}`;
    }

    return returnDate;
  }

  paymentCancel() {
    console.log("payment failed");
    this.reference = `ref-${Math.ceil(Math.random() * 10e13)}`;
    this.couponForm.reset();
  }

  loadScripts() {
    const dynamicScripts = [
      "assets/js/vendor/jquery-1.11.3.min.js",
      "assets/js/bootstrap.min.js",
      "assets/js/wow.min.js",
      "assets/js/jquery-price-slider.js",
      "assets/js/jquery.meanmenu.js",
      "assets/js/owl.carousel.min.js",
      "assets/js/jquery.sticky.js",
      "assets/js/jquery.scrollUp.min.js",
      "assets/js/scrollbar/jquery.mCustomScrollbar.concat.min.js",
      "assets/js/scrollbar/mCustomScrollbar-active.js",
      "assets/js/metisMenu/metisMenu.min.js",
      "assets/js/metisMenu/metisMenu-active.js",
      "assets/js/tab.js",
      "assets/js/icheck/icheck.min.js",
      "assets/js/icheck/icheck-active.js",
      "assets/js/plugins.js",
      "assets/js/main.js",
    ];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement("script");
      node.src = dynamicScripts[i];
      node.type = "text/javascript";
      node.async = false;
      node.charset = "utf-8";
      document.getElementsByTagName("head")[0].appendChild(node);
    }
  }
}
